// Converts "other" disposition quantities to the new adjQuantity attribute for
// submission/storage when the user profile has adjustment enabled.

const OTHER_KEYS = ['otherQuantity', 'other', 'Other'];

const moveOtherToAdj = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;
    const next = { ...obj };
    OTHER_KEYS.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(next, key)) {
            if (next[key] !== undefined) {
                next.adjQuantity = next[key];
            }
            delete next[key];
        }
    });
    return next;
};

const moveAdjToOther = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;
    const next = { ...obj };
    if (Object.prototype.hasOwnProperty.call(next, 'adjQuantity')) {
        if (next.adjQuantity !== undefined) {
            next.otherQuantity = next.adjQuantity;
        }
        delete next.adjQuantity;
    }
    return next;
};

export const convertAdjQuantityToOther = (products) => {
    if (!Array.isArray(products)) return products;
    return products.map((product) => {
        const next = moveAdjToOther(product);
        if (next && Array.isArray(next.lotSerial)) {
            next.lotSerial = next.lotSerial.map(moveAdjToOther);
        }
        return next;
    });
};

/**
 * Returns products with otherQuantity/other converted to adjQuantity at both the
 * item level and the lotSerial level. Only applies when adjustmentDisEnabled.
 */
export const applyAdjDisposition = (products, adjustmentDisEnabled) => {
    if (!adjustmentDisEnabled || !Array.isArray(products)) return products;
    return products.map((product) => {
        const next = moveOtherToAdj(product);
        if (Array.isArray(next.lotSerial)) {
            next.lotSerial = next.lotSerial.map(moveOtherToAdj);
        }
        return next;
    });
};

/**
 * Returns the order payload with its products run through applyAdjDisposition.
 */
export const applyAdjDispositionToOrder = (order, adjustmentDisEnabled) => {
    if (!adjustmentDisEnabled || !order || !Array.isArray(order.products)) {
        return order;
    }
    return {
        ...order,
        products: applyAdjDisposition(order.products, adjustmentDisEnabled),
    };
};

const isQtyPresent = (value) => value === true || parseInt(value) > 0;

/**
 * True when at least one product has an adj disposition quantity, at either the
 * item level or within its lotSerial entries. Reads adjQuantity (post-conversion
 * / stored data) as well as the live "other" field the record screen writes.
 */
export const hasAdjDisposition = (products) => {
    if (!Array.isArray(products)) return false;
    return products.some((product) => {
        if (isQtyPresent(product?.adjQuantity)) return true;
        if (isQtyPresent(product?.otherQuantity)) return true;
        if (Array.isArray(product?.lotSerial)) {
            return product.lotSerial.some(
                (ls) =>
                    isQtyPresent(ls?.adjQuantity) ||
                    isQtyPresent(ls?.other) ||
                    isQtyPresent(ls?.Other) ||
                    isQtyPresent(ls?.otherQuantity)
            );
        }
        return false;
    });
};
